import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { ERoutePaths } from 'libraries/router/types'

import styles from './Error.module.scss'

const Error: FC = () => {
  const navigate = useNavigate()

  const changeToRealRouteHandler = () => {
    navigate(ERoutePaths.Home)
  }

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.wrapper__title}>404</h1>
      <p className={styles.wrapper__subtitle}>Page not found</p>
      <button className={styles.wrapper__button} onClick={changeToRealRouteHandler}>
        Back to Homepage
      </button>
    </div>
  )
}

export default Error
